// extracted by mini-css-extract-plugin
export default {"categoryLink":"_1HL3l","categoryLink_withHomepage":"_1IULR","categoryLinkWithHomepage":"_1IULR","categoryLinkFirstItem":"_3_zcq"};